import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import InAppMessage from "./in-app-message.js";
import u from "../../managers/subscription-manager.js";

var InAppMessageButton = /*#__PURE__*/function () {
  function InAppMessageButton(s, t, i, r, e, h, n) {
    _classCallCheck(this, InAppMessageButton);

    this.text = s || "", this.backgroundColor = t || InAppMessage.ji.bi, this.textColor = i || InAppMessage.ji.ki, this.borderColor = r || this.backgroundColor, this.clickAction = e || InAppMessage.ClickAction.NONE, this.uri = h, null == n && (n = InAppMessageButton.Ue), this.id = n, this.nl = !1, this.lt = new u();
  }

  _createClass(InAppMessageButton, [{
    key: "subscribeToClickedEvent",
    value: function subscribeToClickedEvent(s) {
      return this.lt.ut(s);
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(s) {
      this.lt.removeSubscription(s);
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      this.lt.removeAllSubscriptions();
    }
  }, {
    key: "k",
    value: function k() {
      return !this.nl && (this.nl = !0, this.lt.St(), !0);
    }
  }], [{
    key: "fromJson",
    value: function fromJson(s) {
      return new InAppMessageButton(s.text, s.bg_color, s.text_color, s.border_color, s.click_action, s.uri, s.id);
    }
  }]);

  return InAppMessageButton;
}();

export { InAppMessageButton as default };
InAppMessageButton.Ue = -1;